<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">

                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2">Home</h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Home</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

                
                <!-- Loading -->
                <div v-if="pgLoading" class="row h-100">
                    <div class="container text-center">
                        <div class="spinner-grow mt-5" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <!-- End Loading -->

            <!-- Form -->
            <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

            <div class="tab-content">
                <div class="row">    


                    <div class="col-md-12 mb-5">
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground1" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background1')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground1" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground1">
                                            <span id="iconToggleBackground1" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground1" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground1" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                           
                                            <div class="col-12 row" style='padding:0'>
                                                <div class="form-group col-12">
                                                    <label>Image 1400 * 350
                                                        <button v-if="row.preview1" 
                                                            type="button" 
                                                            class="btn btn-danger btn-sm btn-pill"
                                                            style='margin-top: -10px; margin-left: 10px'
                                                            @click="row.preview1 = ''; row.image1 = ''">
                                                            Remove Image
                                                        </button>
                                                    </label>
                                                    <p><img v-if="row.preview1" 
                                                        :src="row.preview1" 
                                                        style="max-width: 100%">
                                                    </p>
                                                    <input type="file" 
                                                        class="form-control" 
                                                        v-on:change="onImage1Change">
                                                </div>
                                                <div class="form-group col-12 row">
                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Title</label>
             
                                                        <editor
                                                            id="editors0title1"
                                                            v-model="row.title1"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Content</label>
                                                        
                                                        <editor
                                                            id="editors0content1"
                                                            v-model="row.content1"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    
                                                    <div class="col-12 row" style='margin-top:10px'>
                                                        <div class="form-group col-12">
                                                            <label>Button</label>
                                                            <input type="text" 
                                                                v-model="row.button1" 
                                                                class="form-control">
                                                        </div>
                                                        <div class="form-group col-12">
                                                            <label>Redirect</label>
                                                            <input type="text" 
                                                                v-model="row.redirect1" 
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="col-md-12 mb-5">
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground2" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background2')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground2" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground2">
                                            <span id="iconToggleBackground2" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground2" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground2" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                           
                                            <div class="col-12 row" style='padding:0'>
                                                <div class="form-group col-12">
                                                        <label>Image 1400 * 440
                                                            <button v-if="row.preview2" 
                                                                type="button" 
                                                                class="btn btn-danger btn-sm btn-pill"
                                                                style='margin-top: -10px; margin-left: 10px'
                                                                @click="row.preview2 = ''; row.image2 = ''">
                                                                Remove Image
                                                            </button>
                                                        </label>
                                                        <p><img v-if="row.preview2" 
                                                            :src="row.preview2" 
                                                            style="max-width: 100%">
                                                        </p>
                                                        <input type="file" 
                                                            class="form-control" 
                                                            v-on:change="onImage2Change">
                                                </div>
                                                <div class="form-group col-12 row">
                                                    
                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>SubTitle</label>
                                                        
                                                        <editor
                                                            id="editors0subTitle2"
                                                            v-model="row.subTitle2"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Title</label>
                                                        
                                                        <editor
                                                            id="editors0title2"
                                                            v-model="row.title2"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    
                                                    <div class="col-12 row" style='margin-top:10px'>
                                                        <div class="form-group col-12">
                                                            <label>Button</label>
                                                            <input type="text" 
                                                                v-model="row.button2" 
                                                                class="form-control">
                                                        </div>
                                                        <div class="form-group col-12">
                                                            <label>Redirect</label>
                                                            <input type="text" 
                                                                v-model="row.redirect2" 
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div class="col-md-12 mb-5">
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground2" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background3')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground3" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground3">
                                            <span id="iconToggleBackground3" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground3" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground3" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                           
                                            <div class="col-12 row" style='padding:0'>
                                                <div class="form-group col-12">
                                                        <label>Image 680 * 590
                                                            <button v-if="row.preview3" 
                                                                type="button" 
                                                                class="btn btn-danger btn-sm btn-pill"
                                                                style='margin-top: -10px; margin-left: 10px'
                                                                @click="row.preview3 = ''; row.image3 = ''">
                                                                Remove Image
                                                            </button>
                                                        </label>
                                                        <p><img v-if="row.preview3" 
                                                            :src="row.preview3" 
                                                            style="max-width: 100%">
                                                        </p>
                                                        <input type="file" 
                                                            class="form-control" 
                                                            v-on:change="onImage3Change">
                                                </div>
                                                <div class="form-group col-12 row">
                                                    
                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Title</label>
                                                        
                                                        <editor
                                                            id="editors0title3"
                                                            v-model="row.title3"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    
                                                    <div class="col-12 row" style='margin-top:10px'>
                                                        <div class="form-group col-12">
                                                            <label>Button</label>
                                                            <input type="text" 
                                                                v-model="row.button3" 
                                                                class="form-control">
                                                        </div>
                                                        <div class="form-group col-12">
                                                            <label>Redirect</label>
                                                            <input type="text" 
                                                                v-model="row.redirect3" 
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12 mb-5">
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground2" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background4')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground4" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground4">
                                            <span id="iconToggleBackground4" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground4" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground4" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                           
                                            <div class="col-12 row" style='padding:0'>
                                                <div class="form-group col-12">
                                                        <label>Image 340 * 190
                                                            <button v-if="row.preview4" 
                                                                type="button" 
                                                                class="btn btn-danger btn-sm btn-pill"
                                                                style='margin-top: -10px; margin-left: 10px'
                                                                @click="row.preview4 = ''; row.image4 = ''">
                                                                Remove Image
                                                            </button>
                                                        </label>
                                                        <p><img v-if="row.preview4" 
                                                            :src="row.preview4" 
                                                            style="max-width: 100%">
                                                        </p>
                                                        <input type="file" 
                                                            class="form-control" 
                                                            v-on:change="onImage4Change">
                                                </div>
                                                <div class="form-group col-12 row">
                                                    
                                                    <div class="col-12">
                                                        <label>Background Color</label>
                                                        <input type="color" 
                                                                v-model="row.bgColor4" 
                                                                style="height: 60px;width: 100%">
                                                    </div>

                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Title</label>
                                                        
                                                        <editor
                                                            id="editors0title4"
                                                            v-model="row.title4"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    
                                                    <div class="col-12 row" style='margin-top:10px'>
                                                        <div class="form-group col-12">
                                                            <label>Button</label>
                                                            <input type="text" 
                                                                v-model="row.button4" 
                                                                class="form-control">
                                                        </div>
                                                        <div class="form-group col-12">
                                                            <label>Redirect</label>
                                                            <input type="text" 
                                                                v-model="row.redirect4" 
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12 mb-5">
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground2" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background5')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground5" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground5">
                                            <span id="iconToggleBackground5" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground5" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground5" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                           
                                            <div class="col-12 row" style='padding:0'>
                                                <div class="form-group col-12">
                                                        <label>Image 340 * 190
                                                            <button v-if="row.preview5" 
                                                                type="button" 
                                                                class="btn btn-danger btn-sm btn-pill"
                                                                style='margin-top: -10px; margin-left: 10px'
                                                                @click="row.preview5 = ''; row.image5 = ''">
                                                                Remove Image
                                                            </button>
                                                        </label>
                                                        <p><img v-if="row.preview5" 
                                                            :src="row.preview5" 
                                                            style="max-width: 100%">
                                                        </p>
                                                        <input type="file" 
                                                            class="form-control" 
                                                            v-on:change="onImage5Change">
                                                </div>
                                                <div class="form-group col-12 row">
                                                    
                                                    <div class="col-12">
                                                        <label>Background Color</label>
                                                        <input type="color" 
                                                                v-model="row.bgColor5" 
                                                                style="height: 60px;width: 100%">
                                                    </div>

                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Title</label>
                                                        
                                                        <editor
                                                            id="editors0title5"
                                                            v-model="row.title5"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    
                                                    <div class="col-12 row" style='margin-top:10px'>
                                                        <div class="form-group col-12">
                                                            <label>Button</label>
                                                            <input type="text" 
                                                                v-model="row.button5" 
                                                                class="form-control">
                                                        </div>
                                                        <div class="form-group col-12">
                                                            <label>Redirect</label>
                                                            <input type="text" 
                                                                v-model="row.redirect5" 
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-12 mb-5">
                        <div class="card">
                            <div class="card-body">
                                <div id="accordion" class="accordion">
                                    <div id="TabBackground6" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Background6')"
                                            aria-expanded="false" 
                                            aria-controls="collapseBackground6" 
                                            data-toggle="collapse"
                                            data-target="#collapseBackground6">
                                            <span id="iconToggleBackground6" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                    pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseBackground6" 
                                        class="collapse show" 
                                        aria-labelledby="TabBackground6" 
                                        data-parent="#accordion">
                                        <div class="col-12 pt-3">
                                           
                                            <div class="col-12 row" style='padding:0'>
                                                <div class="form-group col-12">
                                                        <label>Image 100 * 145
                                                            <button v-if="row.preview6" 
                                                                type="button" 
                                                                class="btn btn-danger btn-sm btn-pill"
                                                                style='margin-top: -10px; margin-left: 10px'
                                                                @click="row.preview6 = ''; row.image6 = ''">
                                                                Remove Image
                                                            </button>
                                                        </label>
                                                        <p><img v-if="row.preview6" 
                                                            :src="row.preview6" 
                                                            style="max-width: 100%">
                                                        </p>
                                                        <input type="file" 
                                                            class="form-control" 
                                                            v-on:change="onImage6Change">
                                                </div>
                                                <div class="form-group col-12 row">
                                                    
                                                    <div class="col-12">
                                                        <label>Background Color</label>
                                                        <input type="color" 
                                                                v-model="row.bgColor6" 
                                                                style="height: 60px;width: 100%">
                                                    </div>

                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Title</label>
                                                        
                                                        <editor
                                                            id="editors0title6"
                                                            v-model="row.title6"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    

                                                    <div class="form-group col-12" style="margin-top: 10px">
                                                        <label>Sub Title</label>
                                                        
                                                        <editor
                                                            id="editors0subTitle6"
                                                            v-model="row.subTitle6"
                                                            :api-key="editor.api_key"
                                                            :init="{
                                                                height: 300,
                                                                menubar: editor.menubar,
                                                                plugins: editor.plugins,
                                                                toolbar: editor.toolbar
                                                            }"
                                                        />
                                                    </div>
                                                    
                                                    
                                                    <div class="col-12 row" style='margin-top:10px'>
                                                        <div class="form-group col-12">
                                                            <label>Button</label>
                                                            <input type="text" 
                                                                v-model="row.button6" 
                                                                class="form-control">
                                                        </div>
                                                        <div class="form-group col-12">
                                                            <label>Redirect</label>
                                                            <input type="text" 
                                                                v-model="row.redirect6" 
                                                                class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>






                </div>
            </div>

                <div class="col-md-12 row mt-10">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" 
                                :disabled="btnLoading">
                            <span v-if="btnLoading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" 
                                    aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading" class="ti-check-box"></span>
                            <span v-if="!btnLoading"> Update Home</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" 
                            class="btn btn-danger" 
                            :disabled="btnLoading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>


            </form>
            <!-- End Form -->
                
            </div>
            <!-- End Content Body -->

            <Footer></Footer>
            </div>
            <!-- Content -->

        </main>
        <!-- End Main -->
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Home',
        components: {
            Header,
            Navigation,
            Footer,
            Editor
        },
        data(){
            return {
                auth: { 
                    access_token: '',
                },
                row: {

                    // 1
                    preview1: '',
                    image1: '',
                    title1: '',
                    titleColor1: '',
                    content1: '',
                    contentColor1: '',
                    button1: '',
                    redirect1: '',

                    // 2
                    preview2: '',
                    image2: '',
                    subTitle2: '',
                    subTitleColor2: '',
                    title2: '',
                    titleColor2: '',
                    button2: '',
                    redirect2: '',

                    // 3
                    preview3: '',
                    image3: '',
                    title3: '',
                    titleColor3: '',
                    button3: '',
                    redirect3: '',

                    // 4
                    preview4: '',
                    image4: '',
                    bgColor4: '',
                    title4: '',
                    titleColor4: '',
                    button4: '',
                    redirect4: '',


                    // 5
                    preview5: '',
                    image5: '',
                    bgColor5: '',
                    title5: '',
                    titleColor5: '',
                    button5: '',
                    redirect5: '',

                    // 6
                    preview6: '',
                    image6: '',
                    title6: '',
                    titleColor6: '',
                    subTitle6: '',
                    subTitleColor6: '',
                    button6: '',
                    redirect6: '',

                },
                editor: {
                    api_key: 'xahz1dg338xnac8il0tkxph26xcaxqaewi3bd9cw9t4e6j7b',
                    menubar: 'file edit view insert format tools table tc help',
                    plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount'
                            ],
                    toolbar: 'undo redo | formatselect | bold italic backcolor | \
                              alignleft aligncenter alignright alignjustify | \
                              bullist numlist outdent indent | removeformat | help',
                },
                pgLoading: true,
                btnLoading: false,
            }
        },
        mounted() {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            this.fetchRow();
        },
        methods: {

            // fetchRow
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/landingPages/1',
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                        // 1
                        this.row.preview1 = res.data.row.image1;
                        this.row.image1 = res.data.row.image1;
                        this.row.title1 = res.data.row.title1;
                        this.row.titleColor1 = res.data.row.titleColor1;
                        this.row.content1 = res.data.row.content1;
                        this.row.contentColor1 = res.data.row.contentColor1;
                        this.row.button1 = res.data.row.button1;
                        this.row.redirect1 = res.data.row.redirect1;

                        // 2
                        this.row.preview2 = res.data.row.image2;
                        this.row.image2 = res.data.row.image2;
                        this.row.subTitle2 = res.data.row.subTitle2;
                        this.row.subTitleColor2 = res.data.row.subTitleColor2;
                        this.row.title2 = res.data.row.title2;
                        this.row.titleColor2 = res.data.row.titleColor2;
                        this.row.button2 = res.data.row.button2;
                        this.row.redirect2 = res.data.row.redirect2;

                        // 3
                        this.row.preview3 = res.data.row.image3;
                        this.row.image3 = res.data.row.image3;
                        this.row.title3 = res.data.row.title3;
                        this.row.titleColor3 = res.data.row.titleColor3;
                        this.row.button3 = res.data.row.button3;
                        this.row.redirect3 = res.data.row.redirect3;

                        // 4
                        this.row.preview4 = res.data.row.image4;
                        this.row.image4 = res.data.row.image4;
                        this.row.bgColor4 = res.data.row.bgColor4;
                        this.row.title4 = res.data.row.title4;
                        this.row.titleColor4 = res.data.row.titleColor4;
                        this.row.button4 = res.data.row.button4;
                        this.row.redirect4 = res.data.row.redirect4;

                        // 5
                        this.row.preview5 = res.data.row.image5;
                        this.row.image5 = res.data.row.image5;
                        this.row.bgColor5 = res.data.row.bgColor5;
                        this.row.title5 = res.data.row.title5;
                        this.row.titleColor5 = res.data.row.titleColor5;
                        this.row.button5 = res.data.row.button5;
                        this.row.redirect5 = res.data.row.redirect5;

                        // 6
                        this.row.preview6 = res.data.row.image6;
                        this.row.image6 = res.data.row.image6;
                        this.row.title6 = res.data.row.title6;
                        this.row.titleColor6 = res.data.row.titleColor6;
                        this.row.subTitle6 = res.data.row.subTitle6;
                        this.row.subTitleColor6 = res.data.row.subTitleColor6;
                        this.row.button6 = res.data.row.button6;
                        this.row.redirect6 = res.data.row.redirect6;
                        
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // editRow
            editRow(){
                this.btnLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                const options = {
                    url: window.baseURL+'/landingPages/1',
                    method: 'PUT',
                    data: {
                        // 1
                        image1: this.row.image1,
                        title1: this.row.title1,
                        titleColor1: this.row.titleColor1,
                        content1: this.row.content1,
                        contentColor1: this.row.contentColor1,
                        button1: this.row.button1,
                        redirect1: this.row.redirect1,

                        // 2
                        image2: this.row.image2,
                        subTitle2: this.row.subTitle2,
                        subTitleColor2: this.row.subTitleColor2,
                        title2: this.row.title2,
                        titleColor2: this.row.titleColor2,
                        button2: this.row.button2,
                        redirect2: this.row.redirect2,

                        // 3
                        image3: this.row.image3,
                        title3: this.row.title3,
                        titleColor3: this.row.titleColor3,
                        button3: this.row.button3,
                        redirect3: this.row.redirect3,

                        // 4
                        image4: this.row.image4,
                        bgColor4: this.row.bgColor4,
                        title4: this.row.title4,
                        titleColor4: this.row.titleColor4,
                        button4: this.row.button4,
                        redirect4: this.row.redirect4,

                        // 5
                        image5: this.row.image5,
                        bgColor5: this.row.bgColor5,
                        title5: this.row.title5,
                        titleColor5: this.row.titleColor5,
                        button5: this.row.button5,
                        redirect5: this.row.redirect5,

                        // 6
                        image6: this.row.image6,
                        title6: this.row.title6,
                        titleColor6: this.row.titleColor6,
                        subTitle6: this.row.subTitle6,
                        subTitleColor6: this.row.subTitleColor6,
                        button6: this.row.button6,
                        redirect6: this.row.redirect6,
                    }
                }
                this.axios(options, config)
                    .then(() => {
                        this.btnLoading = false;
                        iziToast.success({
                            icon: 'ti-check',
                            title: 'Great job,',
                            message: 'Home Updated Successfully.',
                        });
                        //this.$router.push({ name: 'home' })
                    })
                    .catch(err => {
                        this.btnLoading = false;
                        iziToast.warning({
                            icon: 'ti-alert',
                            title: 'Wow-man,',
                            message: (err.response) ? err.response.data.message : ''+err
                        });
                    })
                    .finally(() => {})
            },

            

            // Upload Featured image
            onImage1Change(e){
                const file = e.target.files[0];
                this.row.preview1 = URL.createObjectURL(file);
                this.createBase64Image1(file);
            },
            createBase64Image1(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image1 = e.target.result;
                };
            },


            onImage2Change(e){
                const file = e.target.files[0];
                this.row.preview2 = URL.createObjectURL(file);
                this.createBase64Image2(file);
            },
            createBase64Image2(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image2 = e.target.result;
                };
            },

            onImage3Change(e){
                const file = e.target.files[0];
                this.row.preview3 = URL.createObjectURL(file);
                this.createBase64Image3(file);
            },
            createBase64Image3(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image3 = e.target.result;
                };
            },

            onImage4Change(e){
                const file = e.target.files[0];
                this.row.preview4 = URL.createObjectURL(file);
                this.createBase64Image4(file);
            },
            createBase64Image4(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image4 = e.target.result;
                };
            },

            onImage5Change(e){
                const file = e.target.files[0];
                this.row.preview5 = URL.createObjectURL(file);
                this.createBase64Image5(file);
            },
            createBase64Image5(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image5 = e.target.result;
                };
            },
            onImage6Change(e){
                const file = e.target.files[0];
                this.row.preview6 = URL.createObjectURL(file);
                this.createBase64Image6(file);
            },
            createBase64Image6(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image6 = e.target.result;
                };
            },


            onImage7Change(e){
                const file = e.target.files[0];
                this.row.preview7 = URL.createObjectURL(file);
                this.createBase64Image7(file);
            },
            createBase64Image7(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image7 = e.target.result;
                };
            },

            onImage8Change(e){
                const file = e.target.files[0];
                this.row.preview8 = URL.createObjectURL(file);
                this.createBase64Image8(file);
            },
            createBase64Image8(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image8 = e.target.result;
                };
            },

            onImage9Change(e){
                const file = e.target.files[0];
                this.row.preview9 = URL.createObjectURL(file);
                this.createBase64Image9(file);
            },
            createBase64Image9(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image9 = e.target.result;
                };
            },



  


            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: 'dashboard' });
                }
            },


            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },



        },
    }
</script>
